export const HomePath = '/';
export const PricesPath = '/price';
export const BlogPath = '/blog';
export const PrivacyPath = '/legal/privacy';
export const TermPath = '/legal/terms';